var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
import axios from 'axios';
import { config, accounts } from '../frontend-config';
var jwToken = function () { return localStorage.getItem('x-cognito-jwt') || ''; };
export var baseURL = function () {
    return sessionStorage.getItem('project_account') || config.apiUrl;
};
export var config_baseURL = function () {
    return sessionStorage.getItem('config_account') || config.apiUrl;
};
export var set_config_baseURL = function (data) {
    return sessionStorage.setItem('config_account', data);
};
export var set_base_configURL = function () {
    return sessionStorage.setItem('config_account', config_baseURL());
};
export var get_config_account = function () {
    return accounts.find(function (a) { return a.url === config_baseURL(); });
};
/**
 * Force the api to use config account instead of project account in using get()
 * @param override
 * @returns
 */
export var set_account_override = function (override) {
    return sessionStorage.setItem('override_pa', override);
};
export var get_account_override = function () { return sessionStorage.getItem('override_pa'); };
export var isBaseURLAll = function () { return baseURL() === 'All'; };
export var allDataFilter = function (data, type) {
    if (isBaseURLAll()) {
        if (type) {
            return data;
        }
        else {
            return data.filter(function (tg) { var _a; return ((_a = tg === null || tg === void 0 ? void 0 : tg.prjacc) === null || _a === void 0 ? void 0 : _a.url) === config_baseURL(); });
        }
    }
    else {
        return data;
    }
};
var axiosInstance = axios.create({
    baseURL: config_baseURL(),
    headers: {
        'x-cognito-jwt': jwToken()
    }
});
export function post(url, payload, headers) {
    axiosInstance.defaults.baseURL = config_baseURL();
    return axiosInstance.post(url, payload, headers);
}
export function get(url, payload) {
    axiosInstance.defaults.baseURL =
        get_account_override() === '1' ? config_baseURL() : baseURL();
    return isBaseURLAll()
        ? getAll(url, payload)
        : axiosInstance.get(url, payload);
}
export function put(url, payload) {
    axiosInstance.defaults.baseURL = config_baseURL();
    return axiosInstance.put(url, payload);
}
export function patch(url, payload, headers) {
    axiosInstance.defaults.baseURL = config_baseURL();
    return axiosInstance.patch(url, payload, headers);
}
export function deletE(url, payload) {
    axiosInstance.defaults.baseURL = config_baseURL();
    return axiosInstance["delete"](url, payload);
}
function getAll(url, payload) {
    var promises = accounts.map(function (acc) {
        return axios({
            url: "" + acc.url + url,
            headers: {
                'x-cognito-jwt': jwToken()
            }
        });
    });
    return Promise.allSettled(promises)
        .then(function (data) {
        return data.filter(function (d) { return d.status === 'fulfilled'; }).map(function (f) { return f.value; });
    })
        .then(function (data) {
        var tempArr = data.reduce(function (acc, current) {
            return current.data ? acc.concat(Object.keys(current.data)) : acc;
        }, []);
        var dataKeys = tempArr.filter(function (item, pos) {
            return tempArr.indexOf(item) == pos;
        });
        if (dataKeys.length > 0 ||
            url.includes('/schedules?startTime')
        // dataKeys[0] !== '0'
        ) {
            var listKey_1 = dataKeys[0];
            var consolidatedData = data.reduce(function (acc, current) {
                var _a;
                var _b, _c;
                var newData = __assign({}, acc);
                var accUrl = new URL(((_b = newData === null || newData === void 0 ? void 0 : newData.config) === null || _b === void 0 ? void 0 : _b.url) || '').origin;
                var accAccount = accounts.find(function (a) { return a.url === accUrl; });
                var currUrl = new URL(((_c = current === null || current === void 0 ? void 0 : current.config) === null || _c === void 0 ? void 0 : _c.url) || '').origin;
                var currAccount = accounts.find(function (a) { return a.url === currUrl; });
                if (url.includes('/schedules?startTime')) {
                    var schedules = newData.data.schedules.map(function (accEl) { return (__assign(__assign({}, accEl), { prjacc: accEl.prjacc || accAccount })); });
                    schedules = schedules.concat(current.data.schedules.map(function (curEl) { return (__assign(__assign({}, curEl), { prjacc: currAccount })); }));
                    var holidays = newData.data.holidays.map(function (accEl) { return (__assign(__assign({}, accEl), { prjacc: accEl.prjacc || accAccount })); });
                    holidays = holidays.concat(current.data.holidays.map(function (curEl) { return (__assign(__assign({}, curEl), { prjacc: currAccount })); }));
                    return __assign(__assign({}, newData), { data: { holidays: holidays, schedules: schedules } });
                }
                else if (dataKeys[0] === '0') {
                    var dataArray = newData.data.map(function (accEl) { return (__assign(__assign({}, accEl), { prjacc: accEl.prjacc || accAccount })); });
                    dataArray = dataArray.concat(current.data.map(function (curEl) { return (__assign(__assign({}, curEl), { prjacc: currAccount })); }));
                    return __assign(__assign({}, newData), { data: dataArray });
                }
                else if (dataKeys.length === 1 &&
                    data[0].data[dataKeys[0]].length !== undefined) {
                    var dataArray = newData.data[listKey_1].map(function (accEl) { return (__assign(__assign({}, accEl), { prjacc: accEl.prjacc || accAccount })); });
                    dataArray = dataArray.concat(current.data[listKey_1].map(function (curEl) { return (__assign(__assign({}, curEl), { prjacc: currAccount })); }));
                    return __assign(__assign({}, newData), { data: (_a = {}, _a[listKey_1] = dataArray, _a) });
                }
                else if (url === '/global/dialerdefaults') {
                    var dataArray = [__assign(__assign({}, newData.data), { prjacc: accAccount })];
                    dataArray.push(__assign(__assign({}, newData.data), { prjacc: currAccount }));
                    return __assign(__assign({}, newData), { data: dataArray });
                }
                else if (url === '/global') {
                    var DialerDefaults = [
                        __assign(__assign({}, newData.data.global.DialerDefaults), { prjacc: accAccount }),
                    ];
                    DialerDefaults.push(__assign(__assign({}, newData.data.global.DialerDefaults), { rjacc: currAccount }));
                    //TODO
                    var Connect = [
                        __assign(__assign({}, newData.data.global.Connect), { prjacc: accAccount }),
                    ];
                    //TODO
                    Connect.push(__assign(__assign({}, newData.data.global.Connect), { rjacc: currAccount }));
                    //TODO
                    return __assign(__assign({}, newData), { data: { global: { DialerDefaults: DialerDefaults, Connect: Connect } } });
                }
                else {
                    var temp = newData.data || current.data;
                    return __assign(__assign({}, newData), { data: temp });
                }
            });
            return consolidatedData;
        }
        else if (url === '/global/dialerdefaults') {
            return data[0];
        }
        else {
            return { data: [] };
        }
    });
}
// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    // Do something before request is sent
    if (config && config.headers) {
        config.headers['x-cognito-jwt'] = jwToken();
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
export default {
    post: post,
    patch: patch,
    get: get,
    put: put,
    deletE: deletE
};
//# sourceMappingURL=utils.js.map